// JobClose AI · Slice 2U · Support API wrapper.
// Read-only fetches for the Support workspace. Every call is admin-gated
// server-side (`require_admin`) and audited (`support.*`).
import { api } from "@/lib/api";

export const supportApi = {
  search: (q, limit = 25) =>
    api.get(`/support/search`, { params: { q, limit } }),
  account: (uid) => api.get(`/support/accounts/${uid}`),
  subscription: (uid) => api.get(`/support/accounts/${uid}/subscription`),
  aggregates: (uid) => api.get(`/support/accounts/${uid}/aggregates`),
  projects: (uid, opts = {}) =>
    api.get(`/support/accounts/${uid}/projects`, { params: opts }),
  projectSummary: (uid, pid) =>
    api.get(`/support/accounts/${uid}/projects/${pid}/summary`),
  diagnostics: (uid) => api.get(`/support/accounts/${uid}/diagnostics`),
  timeline: (uid) => api.get(`/support/accounts/${uid}/timeline`),
};
